import CryptoJs from './lib/crypto-js'

const MD5_KEY = 'V52kPpLS6msz7y3NfZUZ9OKFYeoGysMOeMSPdcObi6onvgmgKKEP5gk3s2omhDDOV3T6SYitc5bKUEzZECnEuN61YvObbu2SD7InNlnWeB8j7M195swDhAYjEnLAI71M'
const EN_KEY = 'b2bc2dcff9074d84'  // 加密秘钥
const DE_KEY = '83fe4c23467507cd'  // 解密秘钥

const fun = {
	// 加密数据
	encryption(data) {
		var timestamp = new Date().getTime(),
			ciphertext = (function(datastr) {
				return CryptoJs.AES.encrypt(datastr, CryptoJs.enc.Utf8.parse(EN_KEY), {
					iv: CryptoJs.enc.Utf8.parse(),
					mode: CryptoJs.mode.ECB,
					padding: CryptoJs.pad.Pkcs7
				}).toString();
			})(JSON.stringify(data));
		
		return {
			ciphertext: ciphertext,
			timestamp: timestamp,
			sign: CryptoJs.MD5(ciphertext + timestamp + MD5_KEY).toString()
		};
	},

	// 解密数据
	deciphering(data) {
		return JSON.parse(
			CryptoJs.AES.decrypt(data, CryptoJs.enc.Utf8.parse(DE_KEY), {
				iv: CryptoJs.enc.Utf8.parse(),
				mode: CryptoJs.mode.ECB,
				padding: CryptoJs.pad.Pkcs7
			}).toString(CryptoJs.enc.Utf8)
		);
	},
	
	/**
	 * 函数防抖
	 * @param  {Function} fun       要执行的方法
	 * @param  {Number}   timer     等待时间
	 * @param  {Booleans} immediate 是否立即执行
	 * @return {Function}           设置防抖后方法
	 */
	debounce(fun, timer, immediate) {
		var timeout, args, context, timestamp, result;
		timer = timer || 500;

		var later = function() {
			var last = new Date().getTime() - timestamp;

			if (last < timer && last >= 0) {
				timeout = setTimeout(later, timer - last);
			} else {
				timeout = null;
				if (immediate === false) {
					result = fun.apply(context, args);
					if (!timeout) context = args = null;
				}
			}
		};

		return function() {
			context = this;
			args = arguments;
			timestamp = new Date().getTime();
			var callNow = immediate !== false && !timeout;
			if (!timeout) timeout = setTimeout(later, timer);
			if (callNow) {
				result = fun.apply(context, args);
				context = args = null;
			}

			return result;
		};
	},

	/**
	 * 函数节流
	 * @param  {Function} fun      执行的方法
	 * @param  {Number}   timer    等待时间
	 * @param  {Booleans} leading  是否立即执行一次
	 * @param  {Booleabs} trailing 是否执行最后一次延时调用
	 * @return {Function}          设置节流后的方法
	 */
	throttle(fun, timer, leading, trailing) {
		timer = timer || 100;
		var context, args, result;
		var timeout = null;
		var previous = 0;
		var later = function() {
			previous = leading === false ? 0 : new Date().getTime();
			timeout = null;
			result = fun.apply(context, args);
			if (!timeout) context = args = null;
		};
		return function() {
			var now = new Date().getTime();
			if (!previous && leading === false) previous = now;
			var remaining = timer - (now - previous);
			context = this;
			args = arguments;
			if (remaining <= 0 || remaining > timer) {
				if (timeout) {
					clearTimeout(timeout);
					timeout = null;
				}
				previous = now;
				result = fun.apply(context, args);
				if (!timeout) context = args = null;
			} else if (!timeout && trailing !== false) {
				timeout = setTimeout(later, remaining);
			}
			return result;
		};
	},

	setCookie(n, v, s) {
		var t = new Date();
		t.setTime(t.getTime() + s * 1000);
		document.cookie = n + "=" + v + ";expires=" + t + ";path=/";
	},

	getCookie(name) {
		var arr = document.cookie.replace(/\s/g, "").split(";");
		for (var i = 0; i < arr.length; i++) {
			var tempArr = arr[i].split("=");
			if (tempArr[0] == name) {
				return decodeURIComponent(tempArr[1]);
			}
		}
		return "";
	},

	removeCookie(name) {
		fun.setCookie(name, "", -1);
	},
	
	getGetParam(name) {
		var search = location.hash.match(/\?(.*)/);
		if (search) {
			var json = {};
			search[1].split('&').forEach(function(item) {
				var t = item.match(/^([^=]+)=(.*)$/);
				try {
					json[t[1]] = JSON.parse(decodeURIComponent(t[2]));
				} catch(e) {
					json[t[1]] = decodeURIComponent(t[2]);
				};
			});
			return name ? json[name] : json;
		}
	},
	
	parseGetParam(json) {
		var data = [];
		for (let i in json) {
			data.push(encodeURIComponent(i) + '=' + encodeURIComponent(typeof json[i] == 'object' ? JSON.stringify(json[i]) : json[i]));
		}
		return data.join('&');
	},

    /**
     * 倒计时
     * @param {String} endDate [结束时间]
     * @param {Function} once [倒计时回调]
     * @param {Function} end [倒计时结束回调]
     * @param {String} opt.sysDate [系统时间]
     * @param {Number, Function} opt.interval [倒计时间隔]
     */
    countdown(endDate, once, end, opt) {
        opt = Object.assign({
            showDay: true,
			showHour: true,
            interval: 1000
        }, opt || {});

        var timer,
            interval = s => {
                return typeof opt.interval == 'function' ? opt.interval(s) : opt.interval;
            };

        endDate = typeof endDate == 'object' ? endDate : [endDate];
        endDate.forEach((item, i) => {
            endDate[i] = opt.sysDate ? praseTime(item) - praseTime(opt.sysDate) + new Date().getTime() : praseTime(item);
        });
        
        function praseTime(str) {
            if (typeof str == 'number') {
                if (`${str}`.length == 10) {
                    return str * 1000;
                } else {
                    return str;
                }
            }
            return (new Date(Date.parse(str.replace(/-/g,"/")))).getTime();
        };

        function getDouble(num) {
            if (num < 10) return '0'+num;
            return num;
        };

        !function loop() {
            var goon = false,
                s = 0;
            endDate.forEach((item, i) => {
                if (item == 'end') return;
                s = item - new Date().getTime();
                
                var t = s < 0 ? 0 : s;
                var day = 0,
					hour = 0;
                if (opt.showDay) {
					day = parseInt((t/86400000).toFixed(10));
					t -= day*86400000;
				}
				if (opt.showHour) {
					hour = getDouble(parseInt((t/3600000).toFixed(10)));
					t -= hour*3600000;
				}
                var min = getDouble(parseInt((t/60000).toFixed(10)));
                t -= min*60000;
                var sec = getDouble(parseInt((t/1000).toFixed(10)));
                t -= sec*1000;
                var ms = parseInt(t/100);
        
                var data = {
                    day: day,
                    hour: hour,
                    min: min,
                    sec: sec,
                    ms: ms,
                    count: s
                };
        
                once && once(data, i);
                if (s <= interval(s)) {
                    endDate[i] = 'end';
                    end && end(data, i);
                } else {
                    goon = true;
                }
            });

            if (goon) timer = setTimeout(loop, interval(s));
        }();

        return {
            abort() {
                clearTimeout(timer);
            }
        }
    }
};
export default fun;
